import { RouteObject } from 'react-router-dom';

const routes: RouteObject[] = [
  {
    path: '/org/:org_id/content',
    children: [
      {
        path: 'hubs',
      },
      {
        path: 'library',
      },
      {
        path: 'recordings/view/:recordingId',
      },
    ],
  },
  {
    path: '/org/:org_id/apps',
  },
  {
    path: '/org/:org_id/manage',
    children: [
      {
        path: 'billing',
      },
      {
        path: 'spaces',
      },
      {
        path: 'team',
        children: [
          {
            path: 'active-members',
          },
          {
            path: 'pending-invites',
          },
        ],
      },
    ],
  },
  {
    path: '/org/:org_id/analytics',
  },
  {
    path: '/org/:org_id/analytics-iframe',
  },
  {
    path: '/org/:org_id',
    children: [
      {
        path: 'events',
      },
      {
        path: 'series',
      },
      {
        path: 'event/:eventSlug',
        children: [
          {
            path: 'team-access',
          },
        ],
      },
    ],
  },
  {
    path: '/create-event-wizard/*',
  },
  {
    path: '/org/:org_id/create-event-wizard/*',
  },
  {
    path: '/org/:org_id/content/recordings/:recordingId',
    children: [
      {
        path: 'editor',
        children: [
          {
            // Required for RecordingEffect's isChildPath() check to pass when
            // navigating directly to an edit URL (/editor/edits/:editId).
            // Without this, matchRoutes returns only 1 result → isChildPath()
            // returns false → RecordingEffect bails → recording never fetches.
            path: 'edits/:editId',
          },
        ],
      },
      {
        path: 'lab',
        children: [
          {
            path: ':tabType',
          },
        ],
      },
    ],
  },
  {
    path: '/org/new',
  },
  {
    path: '/attendee',
    children: [
      {
        path: 'profile',
      },
    ],
  },
  {
    path: '/connections/*',
  },
];

export { routes };
